import { createRouter, createWebHistory } from 'vue-router'
import HomeView_PC from '../views/HomeView_PC.vue'
import HomeView_MS from '../views/HomeView_MS.vue'

const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

const routes_pc = [
  {
    path: '/',
    name: 'home',
    component: HomeView_PC
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue')
  },
  {
    path: '/document/task/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyView.vue')
  },
  {
    path: '/document/task/agreement',
    name: 'agreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/UserAgreementView.vue')
  },
  {
    path: '/document/pdfnote/privacy',
    name: 'privacy1',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPDFnote.vue')
  },
  {
    path: '/document/pdfnote/agreement',
    name: 'agreement1',
    component: () => import(/* webpackChunkName: "about" */ '../views/AgreementPDFnote.vue')
  },
]


const routes_ms = [
  {
    path: '/',
    name: 'home',
    component: HomeView_MS
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue')
  },
  {
    path: '/document/task/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyView.vue')
  },
  {
    path: '/document/task/agreement',
    name: 'agreement',
    component: () => import(/* webpackChunkName: "about" */ '../views/UserAgreementView.vue')
  },
  {
    path: '/document/pdfnote/privacy',
    name: 'privacy1',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrivacyPDFnote.vue')
  },
  {
    path: '/document/pdfnote/agreement',
    name: 'agreement1',
    component: () => import(/* webpackChunkName: "about" */ '../views/AgreementPDFnote.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: isMobile() ? routes_ms : routes_pc
})

export default router
